<template>
  <div>
    <DataTable ref="po"
               :value="employeePositionLists"
               :paginator="true"
               :rows="100" :filters="filters"
               class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.n">
        <template #body="slotProps">
          {{ slotProps.index + 1 }}
        </template>
      </Column>
      <Column
        header="Group" :sortable="true"
        field="parentName"
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['parentName']"/>
        </template>
      </Column>
      <Column
        header="Name" :sortable="true"
        field="value"
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['value']"/>
        </template>
      </Column>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click.prevent="editEmployeePosition(slotProps.data)"/>
          <Button class="p-button-raised p-button-danger"
                  @click.prevent="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
        </template>
      </Column>

    </DataTable>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteEmployeePosition"/>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'accountMasterList',
  data() {
    return {
      dialogShow: false,
      id: '',
      columnList: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  },
  computed: {
    employeePositionLists() {
      return this.$store.state.hr.employeePositionLists
    }
  },
  mounted() {
    this.employeePositionList()
    this.columnNames()
  },
  methods: {
    async employeePositionList() {
      try {
        await this.$store.dispatch('loadHrMasterSetupList', 'EmployeePosition')
      } catch (e) {
      }
    },
    editEmployeePosition(data) {
      this.$emit('employee-Position', data)
    },
    openDeleteDialog(id) {
      this.dialogShow = true
      this.id = id
    },
    async deleteEmployeePosition(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let deleteEmployeeGroup = {
        id: this.id,
        deleteReason: value,
        type: 'EmployeeGroup'
      }
      try {
        let response = await this.$store.dispatch('deleteHrMasterSetup', deleteEmployeeGroup)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: '',
            detail: 'Employee Position ' + response.data.message,
            life: 3000
          })
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// employeePositionList.vue?6e63a36e